
document.addEventListener('DOMContentLoaded', () => {
  const stringsEl = document.getElementById('ThemeStrings');
  const STR = stringsEl ? JSON.parse(stringsEl.textContent) : {};
  const t = (key, fallback='') => STR[key] || fallback;
  const money = (cents, currency) => {
    const value = (cents || 0) / 100;
    const code = currency || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {style:'currency', currency:code, currencyDisplay:'narrowSymbol'}).format(value);
    } catch (e) {
      try {
        return new Intl.NumberFormat('en-US', {style:'currency', currency:code}).format(value);
      } catch (e2) {
        return value.toFixed(2);
      }
    }
  };

  if (document.querySelector('.mobile-sticky-atc')) document.body.classList.add('has-sticky-bar');

  // Countdown timers
  document.querySelectorAll('[data-countdown]').forEach(timer => {
    const end = new Date(timer.dataset.end).getTime();
    const expiredText = timer.dataset.expired || '';
    if (!Number.isFinite(end)) return;
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) {
        timer.innerHTML = `<strong>${escapeHtml(expiredText)}</strong>`;
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      timer.querySelector('[data-days]').textContent = String(d).padStart(2,'0');
      timer.querySelector('[data-hours]').textContent = String(h).padStart(2,'0');
      timer.querySelector('[data-minutes]').textContent = String(m).padStart(2,'0');
      timer.querySelector('[data-seconds]').textContent = String(s).padStart(2,'0');
      setTimeout(tick, 1000);
    };
    tick();
  });

  // Gallery
  document.querySelectorAll('.product-gallery').forEach(gallery => {
    const main = gallery.querySelector('[id^="MainProductImage-"]');
    gallery.querySelectorAll('[data-gallery-image]').forEach(btn => {
      btn.addEventListener('click', () => {
        gallery.querySelectorAll('.product-thumb').forEach(x => x.classList.remove('active'));
        btn.classList.add('active');
        if (main) {
          main.style.opacity = '.2';
          setTimeout(() => {
            main.removeAttribute('srcset');
            main.removeAttribute('sizes');
            main.src = btn.dataset.galleryImage;
            main.style.opacity = '1';
          }, 100);
        }
      });
    });
  });

  // Drawers and search
  const overlay = document.querySelector('[data-overlay]');
  const menuDrawer = document.querySelector('[data-menu-drawer]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const searchOverlay = document.querySelector('[data-search-overlay]');

  const closeDrawers = () => {
    [menuDrawer, cartDrawer].forEach(d => d && d.classList.remove('open'));
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  };
  let reserveTimer = null;
  let reserveEnd = 0;
  const startReserveTimer = () => {
    const box = document.querySelector('[data-cart-reserve]');
    const clock = box?.querySelector('[data-reserve-clock]');
    if (!box || !clock) return;
    const minutes = Number(box.dataset.minutes || 10);
    let stored = 0;
    try { stored = Number(sessionStorage.getItem('dgReserveEnd') || 0); } catch (e) {}
    if (!reserveEnd) reserveEnd = stored > Date.now() ? stored : 0;
    if (!reserveEnd) {
      reserveEnd = Date.now() + minutes * 60000;
      try { sessionStorage.setItem('dgReserveEnd', String(reserveEnd)); } catch (e) {}
    }
    clearInterval(reserveTimer);
    const tick = () => {
      const left = Math.max(0, reserveEnd - Date.now());
      const m = Math.floor(left / 60000);
      const sec = Math.floor((left % 60000) / 1000);
      clock.textContent = `${m}:${String(sec).padStart(2, '0')}`;
      if (left <= 0) clearInterval(reserveTimer);
    };
    tick();
    reserveTimer = setInterval(tick, 1000);
  };

  const openDrawer = drawer => {
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('open');
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    if (drawer === cartDrawer) startReserveTimer();
  };

  document.querySelector('[data-menu-open]')?.addEventListener('click', () => openDrawer(menuDrawer));
  document.querySelector('[data-cart-open]')?.addEventListener('click', async () => {
    await renderCartDrawer();
    openDrawer(cartDrawer);
  });
  document.querySelectorAll('[data-drawer-close]').forEach(b => b.addEventListener('click', closeDrawers));
  overlay?.addEventListener('click', closeDrawers);

  document.querySelector('[data-search-open]')?.addEventListener('click', () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchOverlay.querySelector('input')?.focus(), 50);
  });
  document.querySelector('[data-search-close]')?.addEventListener('click', () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
    document.body.style.overflow = '';
  });

  async function renderCartDrawer() {
    const box = document.querySelector('[data-cart-content]');
    const footer = document.querySelector('[data-cart-footer]');
    const totalEl = document.querySelector('[data-cart-total]');
    if (!box) return;

    box.innerHTML = `<p class="muted">${escapeHtml(t('cartLoading','Loading cart…'))}</p>`;

    try {
      const cart = await fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(r => {
        if (!r.ok) throw new Error('cart');
        return r.json();
      });

      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.classList.toggle('is-empty', !cart.item_count);
        if (cart.item_count) { el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); }
      });

      if (!cart.items.length) {
        box.innerHTML = `<div class="drawer-empty">
          <p>${escapeHtml(t('cartEmpty','Your cart is empty.'))}</p>
          <a href="/collections/all">${escapeHtml(t('continueShopping','Continue shopping'))}</a>
        </div>`;
        if (footer) footer.hidden = true;
        return;
      }

      box.innerHTML = cart.items.map((item, index) => {
        const props = Object.entries(item.properties || {})
          .filter(([k, v]) => k && k[0] !== '_' && v)
          .map(([k, v]) => `${escapeHtml(k)}: ${escapeHtml(String(v))}`)
          .join(' · ');
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : '';
        const bundle = (item.properties && item.properties._bundle) ? escapeHtml(String(item.properties._bundle)) : '';
        const saved = (item.original_line_price || 0) - (item.final_line_price || 0);
        return `
        <div class="drawer-cart-line" data-cart-line="${index + 1}">
          <a href="${item.url || '#'}" class="drawer-cart-image">
            ${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : ''}
          </a>
          <div class="drawer-cart-info">
            <a class="drawer-cart-title" href="${item.url || '#'}">${escapeHtml(String(item.product_title || '').replace(/\s*\(или своё\)/g, ''))}</a>
            ${variant || props ? `<small class="drawer-cart-options">${[variant, props].filter(Boolean).join(' · ')}</small>` : ''}
            <div class="drawer-cart-price">
              ${saved > 0 ? `<s>${money(item.original_line_price, cart.currency)}</s>` : ''}
              <b>${money(item.final_line_price, cart.currency)}</b>
              ${saved > 0 ? `<em>(${escapeHtml(t('youSave','You save'))} ${money(saved, cart.currency)})</em>` : ''}
            </div>
            ${bundle ? `<div class="drawer-cart-tag">${bundle}</div>` : ''}
            <div class="drawer-line-controls">
              <div class="qty-box">
                <button type="button" data-cart-decrease="${index + 1}" aria-label="${escapeHtml(t('decreaseQty','Decrease quantity'))}">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-increase="${index + 1}" aria-label="${escapeHtml(t('increaseQty','Increase quantity'))}">+</button>
              </div>
              <button type="button" class="drawer-remove" data-cart-remove="${index + 1}" aria-label="${escapeHtml(t('remove','Remove'))}">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 7h15M9.5 7V5.4A1.4 1.4 0 0 1 10.9 4h2.2a1.4 1.4 0 0 1 1.4 1.4V7M6.7 7l.8 12a1.6 1.6 0 0 0 1.6 1.5h5.8a1.6 1.6 0 0 0 1.6-1.5l.8-12"/></svg>
              </button>
            </div>
          </div>
        </div>`;
      }).join('');

      const savedTotal = (cart.original_total_price || 0) - (cart.total_price || 0);
      const savedEl = document.querySelector('[data-cart-saved]');
      if (savedEl) {
        savedEl.hidden = !(savedTotal > 0);
        savedEl.textContent = savedTotal > 0 ? `${t('youSave','You save')} ${money(savedTotal, cart.currency)}` : '';
      }

      if (totalEl) totalEl.textContent = money(cart.total_price, cart.currency);
      if (footer) footer.hidden = false;

      box.querySelectorAll('[data-cart-decrease]').forEach(btn => {
        btn.addEventListener('click', () => {
          const line = Number(btn.dataset.cartDecrease);
          const item = cart.items[line - 1];
          changeCartLine(line, Math.max(0, item.quantity - 1));
        });
      });
      box.querySelectorAll('[data-cart-increase]').forEach(btn => {
        btn.addEventListener('click', () => {
          const line = Number(btn.dataset.cartIncrease);
          const item = cart.items[line - 1];
          changeCartLine(line, item.quantity + 1);
        });
      });
      box.querySelectorAll('[data-cart-remove]').forEach(btn => {
        btn.addEventListener('click', () => changeCartLine(Number(btn.dataset.cartRemove), 0));
      });
    } catch (e) {
      box.innerHTML = `<p>${escapeHtml(t('cartError','Unable to load cart.'))}</p>
        <div class="drawer-cart-actions"><a href="/cart">${escapeHtml(t('openCart','Open cart'))}</a></div>`;
      if (footer) footer.hidden = true;
    }
  }

  async function changeCartLine(line, quantity) {
    const box = document.querySelector('[data-cart-content]');
    if (box) box.classList.add('is-loading');
    try {
      await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({line, quantity})
      });
      await renderCartDrawer();
    } finally {
      if (box) box.classList.remove('is-loading');
    }
  }

  function escapeHtml(str='') {
    return String(str).replace(/[&<>"']/g, m => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'
    }[m]));
  }

  // Product: bundles with per-item color / size
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const sectionId = section.dataset.productSection;
    const jsonEl = document.getElementById(`ProductJson-${sectionId}`);
    const form = document.getElementById(`ProductForm-${sectionId}`);
    if (!jsonEl || !form) return;

    const data = JSON.parse(jsonEl.textContent);
    const variants = data.variants || [];
    const cur = data.currency;
    const cIdx = Number(data.colorIndex);
    const sIdx = Number(data.sizeIndex);
    const variantInput = document.getElementById(`VariantId-${sectionId}`);
    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    const priceEl = document.getElementById(`Price-${sectionId}`);
    const compareEl = document.getElementById(`ComparePrice-${sectionId}`);
    const addBtn = document.getElementById(`AddToCart-${sectionId}`);
    const buyNowBtn = section.querySelector('[data-buy-now]');
    const dynPay = section.querySelector('[data-dynamic-payment]');
    const mainImg = document.getElementById(`MainProductImage-${sectionId}`);
    const bundles = [...section.querySelectorAll('[data-bundle]')];
    const primaryBtn = addBtn || buyNowBtn;
    const addText = addBtn?.textContent?.trim() || t('addToCart','ADD TO CART');
    const buyText = buyNowBtn?.textContent?.trim() || '';
    const norm = v => String(v ?? '').trim().toLowerCase();

    const activeBundle = () => bundles.find(b => b.classList.contains('is-active')) || bundles[0];

    const slotChoice = slot => ({
      color: slot.querySelector('[data-opt="color"] .dg-chip.is-active')?.dataset.value ?? null,
      size: slot.querySelector('[data-opt="size"] .dg-chip.is-active')?.dataset.value ?? null
    });

    const findVariant = ch => {
      const ok = v =>
        (cIdx < 0 || ch.color === null || norm(v.options[cIdx]) === norm(ch.color)) &&
        (sIdx < 0 || ch.size === null || norm(v.options[sIdx]) === norm(ch.size));
      const list = variants.filter(ok);
      return list.find(v => v.available) || list[0] || null;
    };

    const lineFor = slot => {
      const ch = slotChoice(slot);
      const v = findVariant(ch);
      const props = {};
      if (cIdx < 0 && ch.color) props[data.colorLabel || 'Color'] = ch.color;
      if (sIdx < 0 && ch.size) props[data.sizeLabel || 'Size'] = ch.size;
      return {v, props};
    };

    const bundleLines = b => [...b.querySelectorAll('[data-slot]')].map(lineFor);

    const missingOpts = b => [...b.querySelectorAll('[data-opt]')].filter(o => !o.querySelector('.dg-chip.is-active'));
    const isComplete = b => b && missingOpts(b).length === 0;

    const priceOf = b => {
      const lines = bundleLines(b);
      const disc = Number(b.dataset.discount || 0);
      const fixed = parseFloat(String(b.dataset.fixed || '').replace(/[^0-9.,]/g, '').replace(',', '.'));
      let base = 0, compare = 0;
      lines.forEach(({v}) => {
        if (!v) return;
        base += v.price;
        compare += Math.max(v.compare_at_price || 0, v.price);
      });
      const total = Number.isFinite(fixed) && fixed > 0 ? Math.round(fixed * 100) : Math.round(base * (1 - disc / 100));
      const percent = base > 0 ? Math.round((base - total) / base * 100) : 0;
      return {lines, total, compare, percent, ok: lines.every(l => l.v && l.v.available)};
    };

    const refresh = () => {
      bundles.forEach(b => {
        const {total, compare, percent} = priceOf(b);
        const tEl = b.querySelector('[data-total]');
        const cEl = b.querySelector('[data-compare]');
        const sEl = b.querySelector('[data-save]');
        const pEl = b.querySelector('[data-percent]');
        if (pEl) { pEl.textContent = percent > 0 ? `${t('saveWord','SAVE')} ${percent}%` : ''; pEl.hidden = !(percent > 0); }
        if (tEl) tEl.textContent = money(total, cur);
        if (cEl) { cEl.hidden = !(compare > total); cEl.textContent = money(compare, cur); }
        if (sEl) { const save = compare - total; sEl.hidden = !(save > 0); sEl.textContent = `${t('youSave','You save')} ${money(save, cur)}`; }
        b.querySelectorAll('[data-opt]').forEach(o => {
          const val = o.querySelector('.dg-chip.is-active')?.dataset.value || '';
          const lab = o.querySelector('[data-opt-value]');
          if (lab) lab.textContent = val;
        });
        const sum = b.querySelector('[data-summary]');
        if (sum) {
          const done = isComplete(b);
          const text = [...b.querySelectorAll('[data-slot]')].map(slot => {
            const c = slotChoice(slot);
            return [c.color, c.size].filter(Boolean).join(', ');
          }).filter(Boolean).join('  +  ');
          sum.textContent = text;
          sum.hidden = !(done && text && b.classList.contains('is-active') && !b.classList.contains('is-open'));
          const sub = b.querySelector('.dg-bundle__sub');
          if (sub) sub.hidden = !sum.hidden;
        }
      });

      const b = activeBundle();
      if (!b) return;
      const {lines, total, compare, ok} = priceOf(b);
      const first = lines[0]?.v;
      if (first && variantInput) variantInput.value = first.id;
      if (quantityInput) quantityInput.value = lines.length;
      if (priceEl) priceEl.textContent = money(total, cur);
      if (compareEl) { compareEl.hidden = !(compare > total); compareEl.textContent = money(compare, cur); }
      document.querySelectorAll(`[data-mobile-sticky][data-section-id="${sectionId}"] [data-sticky-price]`)
        .forEach(x => x.textContent = money(total, cur));
      if (dynPay) dynPay.hidden = lines.length > 1 || lines.some(l => Object.keys(l.props).length > 0);
      const complete = isComplete(b);
      if (complete) bundles.forEach(x => x.classList.remove('needs-choice'));
      if (addBtn) {
        addBtn.disabled = !ok && complete;
        if (!ok) addBtn.textContent = lines.some(l => !l.v) ? t('unavailable','UNAVAILABLE') : t('soldOut','SOLD OUT');
        else addBtn.textContent = addText;
      }
      if (buyNowBtn) {
        buyNowBtn.disabled = !ok && complete;
        if (!addBtn) {
          if (!ok) buyNowBtn.textContent = lines.some(l => !l.v) ? t('unavailable','UNAVAILABLE') : t('soldOut','SOLD OUT');
          else buyNowBtn.textContent = buyText;
        }
      }
    };

    const setImage = src => {
      if (!mainImg || !src || mainImg.src === src) return;
      mainImg.style.opacity = '.2';
      setTimeout(() => { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = src; mainImg.style.opacity = '1'; }, 100);
    };

    const selectBundle = (b, open) => {
      bundles.forEach(x => {
        x.classList.toggle('is-active', x === b);
        x.setAttribute('aria-checked', x === b);
        if (x !== b) x.classList.remove('is-open');
      });
      if (open === true) b.classList.add('is-open');
      else if (open === false) b.classList.remove('is-open');
      refresh();
    };

    bundles.forEach(b => {
      b.addEventListener('click', e => {
        if (e.target.closest('.dg-chip') || e.target.closest('.dg-bundle__body')) return;
        const wasActive = b.classList.contains('is-active');
        selectBundle(b, !(wasActive && b.classList.contains('is-open')));
      });
      b.addEventListener('keydown', e => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === b) {
          e.preventDefault();
          const wasActive = b.classList.contains('is-active');
          selectBundle(b, !(wasActive && b.classList.contains('is-open')));
        }
      });
      b.querySelectorAll('.dg-chips').forEach(group => {
        group.addEventListener('click', e => {
          const chip = e.target.closest('.dg-chip');
          if (!chip) return;
          group.querySelectorAll('.dg-chip').forEach(x => x.classList.toggle('is-active', x === chip));
          if (!b.classList.contains('is-active')) selectBundle(b, true); else refresh();
          if (chip.classList.contains('dg-chip--color')) {
            const {v} = lineFor(chip.closest('[data-slot]'));
            if (v?.image) setImage(v.image);
          }
        });
      });
    });
    refresh();

    const addLines = async () => {
      const {lines} = priceOf(activeBundle());
      const bundleName = activeBundle()?.dataset.name || '';
      const items = lines.map(({v, props}) => ({
        id: v.id, quantity: 1,
        properties: Object.assign({}, props, lines.length > 1 ? {_bundle: bundleName} : {})
      }));
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items})
      });
      if (!res.ok) throw new Error('add');
    };

    const flash = (btn, text, back, ms) => { btn.textContent = text; setTimeout(() => { btn.textContent = back; refresh(); }, ms); };

    const requireChoice = () => {
      const b = activeBundle();
      if (!b || isComplete(b)) return false;
      selectBundle(b, true);
      b.classList.add('needs-choice');
      const missing = missingOpts(b);
      missing.forEach(o => { o.classList.remove('is-missing'); void o.offsetWidth; o.classList.add('is-missing'); });
      missing[0]?.scrollIntoView({behavior: 'smooth', block: 'center'});
      return true;
    };

    const onAdd = async e => {
      e?.preventDefault();
      if (!addBtn) return;
      if (requireChoice()) return;
      if (data.demo) return flash(addBtn, t('selectProduct','SELECT A REAL SHOPIFY PRODUCT'), addText, 1500);
      addBtn.disabled = true;
      addBtn.textContent = t('adding','ADDING…');
      try {
        await addLines();
        if (typeof renderCartDrawer === 'function') await renderCartDrawer();
        if (typeof openDrawer === 'function' && typeof cartDrawer !== 'undefined') openDrawer(cartDrawer);
        flash(addBtn, t('added','ADDED ✓'), addText, 1200);
      } catch (err) {
        flash(addBtn, t('tryAgain','TRY AGAIN'), addText, 1400);
      }
    };
    if (form.tagName === 'FORM' && addBtn) {
      form.addEventListener('submit', e => {
        if (e.submitter?.classList.contains('shopify-payment-button__button')) return;
        onAdd(e);
      });
    } else addBtn?.addEventListener('click', onAdd);

    buyNowBtn?.addEventListener('click', async () => {
      if (requireChoice()) return;
      if (data.demo) return flash(buyNowBtn, t('selectProduct','SELECT A REAL SHOPIFY PRODUCT'), buyText, 1500);
      const openNew = buyNowBtn.dataset.newTab === 'true';
      const win = openNew ? window.open('', '_blank') : null;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = t('loading','LOADING…');
      const checkout = `${window.Shopify?.routes?.root || '/'}checkout`;
      try {
        await addLines();
        if (win) win.location = checkout; else window.location.href = checkout;
      } catch (err) {
        if (win) win.close();
        flash(buyNowBtn, t('tryAgain','TRY AGAIN'), buyText, 1400);
      }
    });

    document.querySelectorAll(`[data-mobile-sticky][data-section-id="${sectionId}"] [data-sticky-add]`).forEach(btn => {
      btn.addEventListener('click', () => primaryBtn?.click());
    });
  });

  // Photo reviews: show more
  document.querySelectorAll('[data-review-grid]').forEach(grid => {
    const section = grid.closest('section');
    const btn = section?.querySelector('[data-reviews-more]');
    if (!btn) return;
    const cards = [...grid.querySelectorAll('.pr-card')];
    const visible = Number(grid.dataset.visible || 6);
    if (cards.length <= visible) { btn.hidden = true; return; }
    cards.slice(visible).forEach(c => c.classList.add('is-hidden'));
    btn.addEventListener('click', () => {
      cards.forEach(c => c.classList.remove('is-hidden'));
      btn.hidden = true;
    });
  });

  // Video slider
  document.querySelectorAll('[data-slider]').forEach(slider => {
    const track = slider.querySelector('[data-track]');
    slider.querySelector('[data-prev]')?.addEventListener('click', () =>
      track.scrollBy({left:-track.clientWidth*.8,behavior:'smooth'})
    );
    slider.querySelector('[data-next]')?.addEventListener('click', () =>
      track.scrollBy({left:track.clientWidth*.8,behavior:'smooth'})
    );
  });
});
